import canBeRichEdited from '../../../constraints/verifiers/can-be-rich-edited';
import getAdvancedSelection from '../../../text-formatting/accessors/get-advanced-selection';
import getBlockFirstChildElementTag from '../../../content-editable/helpers/get-block-first-child-element-tag';
import { NBSP_STRING } from '../../../content-editable/constants/common';
import getBlockFirstChildElement from '../../../content-editable/helpers/get-block-first-child-element';
import { DEFAULT_BLOCK_TAG } from '../../../content-editable/constants/editable-elements';

/**
 * It should be executed on keydown in order to apply changes before
 * live node synchronization with static node
 * */
const insertSpaceOnKeydown = (e) => {
  const { srcElement } = e;
  const { ownerDocument: liveDocument } = srcElement;
  const firstElementChildTag = getBlockFirstChildElementTag(srcElement) || DEFAULT_BLOCK_TAG;

  /**
   * we use `requestAnimationFrame` here since we can't check how
   * content will look after event happens, so if we remove symbol, node
   * will have non changed content, content will be changed after
   * execution event handlers. So we should do it right after changes
   * are applied, or before it's rendered on the screen.
   * */

  requestAnimationFrame(() => {
    const isTextWrapper = canBeRichEdited(srcElement);
    if (srcElement.innerText) {
      if (!isTextWrapper) return;

      const nativeDiv = srcElement.querySelector('div');
      if (!srcElement.innerText.trim() && nativeDiv) {
        nativeDiv.remove();
      } else {
        return;
      }
    }

    const nodeWithSpace = liveDocument.createTextNode(NBSP_STRING);
    const selection = getAdvancedSelection();
    if (isTextWrapper) {
      /** Preserve last block element in contenteditable element when it is empty
       * It is necessary to avoid some troubles with text formatting
       * */

      const firstElementChild = liveDocument.createElement(firstElementChildTag);
      firstElementChild.appendChild(nodeWithSpace);

      const firstChildNode = getBlockFirstChildElement(srcElement);
      if (firstChildNode) {
        firstChildNode.replaceWith(firstElementChild);
      } else {
        srcElement.prepend(firstElementChild);
      }

      selection.collapse(firstElementChild, 0);
    } else {
      srcElement.prepend(nodeWithSpace);
      selection.collapse(srcElement, 0);
    }
  });
};

export default insertSpaceOnKeydown;
